// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
}

.filter-bar {
  font-size: 16px;
  color: #555;
  flex-grow: 1;
  height: 41px;
  display: flex;
}

.filter-bar input {
  width: 100%;
  font-size: 16px;
  color: #555;
  border: none;
  height: 100%;
}

.filter-by {
  margin-right: 11px;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.label {
  margin-right: 8px;
  margin-left: 8px;
  color: var(--theme-main-color, #055C8D);
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: 0.305883px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 60px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
